var is = require('./is');

    /**
     * Check if both values are not identical/egal
     */
    function isnt(x, y){
        return !is(x, y);
    }

    module.exports = isnt;





//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isnt.js
// module id = 1613
// module chunks = 0 1 2